import { css } from '@emotion/react'
import { SIDE_MENU_Z_INDEX } from 'components/layout/SideMenu/SideMenuNav'
import { LeafletMap } from 'components/map/LeafletMap'
import { useMemo, useRef } from 'react'
import { emptyArrayOf } from 'util/array'

import { TerritorioMapaBuscaFormModel } from '../mapa-busca/model-territorioMapaBusca'
import { hasFiltrosAvancados } from '../mapa-busca/utils-territorioMapaBusca'
import { TerritorioPinoModel, TerritorioPinoQueryModel } from '../model-territorioMapa'
import { toMapMarkers } from '../utils-territorioMapa'
import { MapaBarraFiltrosAplicados } from './MapaBarraFiltrosAplicados'
import { MapaTerritorioFeedback } from './MapaTerritorioFeedback'

interface TerritorioMapaProps {
  pinosTerritorio: TerritorioPinoQueryModel | undefined
  isLoading: boolean
  filtrosAvancados: TerritorioMapaBuscaFormModel['filtrosAvancados']
}

export function TerritorioMapa(props: Readonly<TerritorioMapaProps>) {
  const { pinosTerritorio, isLoading, filtrosAvancados } = props

  const filterBarRef = useRef<HTMLDivElement>(null)

  const imoveis = pinosTerritorio?.content ?? emptyArrayOf<TerritorioPinoModel>()
  const markers = useMemo(() => toMapMarkers(imoveis), [imoveis])
  const mapFeedback = pinosTerritorio ? <MapaTerritorioFeedback pinosTerritorio={pinosTerritorio} /> : null

  return (
    <div css={styles.mapWrapper}>
      <div ref={filterBarRef} css={styles.filterBar}>
        {hasFiltrosAvancados(filtrosAvancados) && <MapaBarraFiltrosAplicados appliedFilters={filtrosAvancados} />}
      </div>
      <LeafletMap
        zoom={16}
        markers={markers}
        mapFeedback={mapFeedback}
        showLoading={isLoading}
        topOverlayRef={filterBarRef}
        clusterize
      />
    </div>
  )
}

const styles = {
  mapWrapper: css`
    position: relative;
  `,
  filterBar: css`
    position: absolute;
    width: 100%;
    z-index: ${SIDE_MENU_Z_INDEX - 1};
  `,
}
